<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 6.99999C0 3.13397 3.13399 0 7.00001 0C10.866 0 14 3.13398 14 6.99999C14 10.866 10.866 14 7.00001 14C3.134 14 0 10.866 0 6.99999ZM6.2899 10.0619L10.8556 5.4962C11.1383 5.21352 11.1383 4.7552 10.8556 4.47251C10.5729 4.18983 10.1146 4.18983 9.83188 4.47251L5.77806 8.52633L3.74005 6.48832C3.45735 6.20563 2.99904 6.20564 2.71636 6.48832C2.43368 6.771 2.43368 7.22933 2.71636 7.512L5.26622 10.0619C5.40756 10.2032 5.59281 10.2739 5.77806 10.2739C5.96331 10.2739 6.14856 10.2032 6.2899 10.0619Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class SuccessIcon extends Vue {}
</script>
